<div
    cdkDropList
    (cdkDropListDropped)="drop($event)"
    class="px-2 transition duration-300 ease-in-out">
    <div
        *ngFor="let column of componentModel.columns; let i = index; trackBy: trackByFn"
        cdkDrag
        [cdkDragData]="column"
        class="flex flex-row gap-2 px-4 py-2 items-center space-x-2 p-3 mb-2 rounded-lg cursor-move bg-slate-200 dark:bg-slate-700 shadow-sm transition-all duration-200">
        <div class="flex-1 flex flex-row gap-2">
            <mat-icon class="my-auto cursor-move" svgIcon="mat_outline:drag_indicator"></mat-icon>
            <span class="font-semibold">{{ column.columnName }}</span>
        </div>
        <span> {{ i + 1 }} </span>

        <!-- Optional: You can add a drag icon or indicator -->
        <span class="ml-auto">
            <i class="fas fa-arrows-alt"></i>
        </span>
    </div>
</div>
